module.exports = __webpack_public_path__ + "assets/fonts/GothamProNarrow-Bold.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/gothampro/GothamProNarrow-Bold.eot
// module id = 1908
// module chunks = 0